import { ReactElement, useState } from 'react';
import styles from './onboard-page.module.scss';
import {
    JoinOrCreateCompany,
    NewCompanyOnboarding
} from '@/companies/components';
import { UICard } from '@/ui';
import { useMe } from '@/me/providers';
import { useCreateCompanyAction } from '@/companies/actions';

export function OnboardPage(): ReactElement {
    const [page, setPage] = useState<number>(0);

    const {
        me: { email }
    } = useMe();

    const { createCompany, loading } = useCreateCompanyAction();

    return (
        <div className={styles.page}>
            {page === 0 && (
                <UICard className={styles.card}>
                    <JoinOrCreateCompany
                        onCreateCompany={() => {
                            setPage(1);
                        }}
                    />
                </UICard>
            )}

            {page === 1 && (
                <NewCompanyOnboarding
                    userEmail={email}
                    loading={loading}
                    onSubmit={(data) => {
                        createCompany(data).catch(() => {}); // Error handled in the service
                    }}
                    onBack={() => {
                        setPage(0);
                    }}
                />
            )}
        </div>
    );
}
